export async function getJokeOfTheDay() {
  const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
  const res = await fetch(`${API_BASE}/api/joke-of-the-day/`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
